import { showToast } from '@/features/toasts/toastsSlice';
import { useWorkspace } from '@/features/workspaces/hooks';
import { DeleteModalWithConfirmInput } from '@/lib/Modals';
import { DataSource } from '@/models/dataSource';
import { ToastType } from '@/models/toast';
import { useAppDispatch } from '@/reducers';
import { useDeleteDataSourceMutation } from '@/services/dataSources';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type DeleteDataSourceModalProps = {
  datasource: DataSource | undefined;
  closeModal: VoidFunction;
};

export const DeleteDataSourceModal: FC<DeleteDataSourceModalProps> = ({ datasource, closeModal }) => {
  const { t } = useTranslation('data_source_details');

  const workspace = useWorkspace();

  const [deleteDataSource, { isLoading }] = useDeleteDataSourceMutation();

  const dispatch = useAppDispatch();

  const handleDeleteDataSourceClicked = async () => {
    if (workspace.id && datasource && datasource.id)
      await deleteDataSource({
        workspaceId: workspace.id,
        dataSourceId: datasource.id,
      }).then(async () => {
        closeModal();
        dispatch(
          showToast({
            type: ToastType.SUCCESS,
            title: t('settings.delete.datasource_eliminated'),
            message: t('settings.delete.removed_successfully', { dataSourceName: datasource?.name }),
          })
        );
      });
  };

  return (
    <DeleteModalWithConfirmInput
      inputComparisonValue={datasource.name}
      confirmText={'data_source_details:settings.delete.delete_this_datasource'}
      onConfirm={handleDeleteDataSourceClicked}
      onClose={closeModal}
      isLoading={isLoading}
    >
      <DeleteModalWithConfirmInput.Title>{t('settings.delete.delete_edit_title')}</DeleteModalWithConfirmInput.Title>

      <DeleteModalWithConfirmInput.InputHint>
        {t('settings.delete.confirm_deletion')}&nbsp;(<b>{datasource?.name}</b>)
      </DeleteModalWithConfirmInput.InputHint>
    </DeleteModalWithConfirmInput>
  );
};
